<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showError" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          Por favor, selecione pelo menos uma empresa.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showError = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a
          {{ this.dias }} dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterDownload" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center"> Em Manutenção </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilterDownload = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #f8f9fb">
      <v-col cols="12">
        <filtro-component
          :modos="modos"
          :tipos="tipos"
          @filtrar="filterData"
          @showError="showError = true"
          :calendar="'mes'"
        ></filtro-component>
      </v-col>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" lg="6"> </v-col>
        <v-col cols="12" sm="3" lg="3">
          <base-material-stats-card
            color="red"
            icon="mdi-grave-stone"
            title="Total de Óbitos"
            sub-icon-color="red"
            :valuex="false"
            :value="this.total_falecidos"
            :sub-text="'Total de Falecidos'"
          />
        </v-col>
        <v-col cols="12" sm="3" lg="3">
          <base-material-stats-card
            color="blue"
            icon="mdi-file-document-outline"
            title="Total de Contratos"
            sub-icon-color="blue"
            :valuex="false"
            :value="this.total_contratos"
            :sub-text="'Total de Contratos Vinculados'"
          />
        </v-col>
      </v-row>
    </v-container>
    <br />

    <v-divider></v-divider>

    <br /><br />

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-grave-stone"
            title="Óbitos"
            color="red"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="ranking_header"
              :items="listagem_falecidos"
              :items-per-page="20"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />

              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="orange"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <!-- ID -->
                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ row.item.idFalecido }}
                  </td>

                  <!-- Contrato -->
                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ row.item.contrato }}
                  </td>

                  <!-- Empresa -->
                  <td class="linha" style="width: 15%; font-size: 14px">
                    <v-chip
                      :color="getStatus(row.item.empresa)"
                      text-color="white"
                    >
                      {{ row.item.empresa }}
                    </v-chip>
                  </td>

                  <!-- Falecido -->
                  <td class="linha" style="width: 20%; font-size: 14px">
                    {{ row.item.falecido }}
                  </td>

                  <!-- Inadimplência -->
                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ formatDateBR(row.item.dtFalecimento) }}
                  </td>

                  <!-- Titular -->
                  <td class="linha" style="width: 20%; font-size: 14px">
                    {{ row.item.titular }}
                  </td>

                  <!-- Quantidade agrupada -->
                  <td class="linha" style="width: 8%; font-size: 14px">
                    {{ row.item.quantidade }}
                  </td>
                </tr>
              </template>
            </v-data-table>

            <br />

            <div class="d-flex justify-end">
              <div style="width: 80px">
                <span
                  @click="download_xls"
                  style="
                    color: orange;
                    font-size: 48px;
                    margin-right: 12px;
                    cursor: pointer;
                  "
                >
                  <i class="fas fa-file-excel"></i>
                </span>

                <br />
              </div>
            </div>

            <br />
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import FiltroComponent from "./components/FiltroFalecidos.vue"; // Certifique-se de que o caminho esteja correto
import Sinistralidade from "../../services/sinistralidade";
import { ContentLoader } from "vue-content-loader";
import Falecidos from "../../services/falecidos";
export default {
  name: "Obitos",
  components: {
    apexcharts: VueApexCharts,
    FiltroComponent,
    ContentLoader,
  },

  created() {
    (this.selectedStartDate = this.getFirstDayOf60YearsAgo()),
      (this.selectedEndDate = this.formatDateBR(new Date()));
  },

  data() {
    return {
      ranking_header: [
        { text: "ID", value: "idFalecido" },
        { text: "Contrato", value: "contrato" },
        { text: "Empresa", value: "empresa" },
        { text: "Falecido", value: "falecido" },
        { text: "Data de Falecimento", value: "dtFalecimento" },
        { text: "Titular", value: "titular" },
        { text: "Quantidade de contratos vinculados", value: "quantidade" },
      ],
      empresa: "Todas",
      selectedCompany: "Todas",
      selectedType: "Todos",
      selectMode: "Vencimento",
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      modos: ["Data de Falecimento"],
      showFilter: false,
      showError: false,
      showProgress: false,
      showFilterDownload: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "Todas",
      ],
      tipos: ["Todos", "Planos", "Cemitérios"],
      lista_nome_empresa: [],
      listagem_falecidos: [],
      total_falecidos: null,
      total_contratos: null,
      dias: 60,
    };
  },

  methods: {
    isDateValid(dateString) {
      // Verifica se a string é uma data válida
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    areDatesValid(dates) {
      // Verifica se todas as datas na matriz são válidas
      return dates.every((dateString) => {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
      });
    },

    filterData(valores) {
      this.carregarLoad(), (this.isLoading = true);
      this.selectedType = valores.selectedType;
      this.selectedCompany = valores.selectedCompany.join(",");
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.dashboard();
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    startAnimation(targetValue) {
      this.animationInterval = setInterval(() => {
        if (this.animatedValue < targetValue) {
          this.animatedValue += 1; // Atualiza o valor animado
        } else {
          clearInterval(this.animationInterval); // Interrompe a animação quando atingir o valor desejado
        }
      }, 10); // Intervalo em milissegundos entre cada atualização
    },

    formatDateBR(date) {
      if (!date) return "";
      if (typeof date === "string") {
        const iso = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (iso) {
          return `${iso[3]}/${iso[2]}/${iso[1]}`;
        }
      }
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0");
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateBRAPI(date) {
      if (!date) return "";
      const parsedDate = new Date(this.formatDateBR(date));
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      return `${year}-${month}-${day}`;
    },

    carregarLoad() {
      this.bool_03 = true;
      this.bool_03 = true;
    },

    async dashboard() {
      this.isLoading = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);


      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate
      );

      if (diferencaEmDias > 25550) {
        this.isLoading = false;
        this.showFilter = true;
        this.showProgress = false;
        this.dias = 25550;
        return;
      }

      Falecidos.listagem_falecidos(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        1,
        65000
      )
        .then((response) => {
          if (response.status === 200) {
            this.listagem_falecidos = response.data.lista_falecido;
            this.total_falecidos = response.data.qtd;
            this.total_contratos = response.data.qtdContratos;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    getFirstDayOf60YearsAgo() {
      const dataAtual = new Date();
      const anoAtual = dataAtual.getFullYear();
      const ano60Atras = anoAtual - 60;
      const primeiroDiaDoAno60Atras = new Date(ano60Atras, 0, 1); // Janeiro é representado como 0
      return this.formatDateBR(primeiroDiaDoAno60Atras);
    },

    download_xls() {
      this.showProgress = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate
      );

      if (diferencaEmDias > 25550) {
        this.isLoading = false;
        this.showFilter = true;
        this.showProgress = false;
        this.dias = 25550;
        return;
      }

     
      Falecidos.listagem_falecidos_xls(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        1,
        10
      )
        .then((response) => {
          if (response.status === 200) {
            const fileName = `falecidos_${Date.now()}.xlsx`;
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          // Lida com erros
          console.error("Erro ao baixar o arquivo Excel:", error);
        })
        .finally(() => {
          // Após o término do download, oculte o diálogo de progresso
          this.showProgress = false;
        });
    },

    formatarMoeda(valor) {
      // Verifica se o valor é numérico
      if (isNaN(valor)) {
        return "Valor inválido";
      }

      // Formata o valor como moeda brasileira (BRL)
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    getStatus(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    clear() {
      this.$refs.form.reset();
    },
  },
};


function converteDataParaFormatoISO(dataNoFormatoBR) {
  if (!dataNoFormatoBR) return null;
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null; // Retorna null se a data estiver em um formato inválido
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: #e7f1ff; /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: #90d34c21;
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}
</style>
